
import React, { Component } from 'react';
import {
  Row, Col, Card, CardBody
} from 'reactstrap';
class VehicleCountDeatil extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vehicleData: {
        totalCountBus: 0,
        totalCountTruck: 0,
        totalCountIcv: 0,
        totalCountLcv: 0,
        totalCountScv: 0,
        totalCountPickup: 0,
        totalCountRetread: null
      },
      vehicleDeailError: false,
      rethreadError: false,
      isDisable: this.props.isDisable ? this.props.isDisable : false
    }
  }
  setData = (data, is_handlevalidation = true) => {
    this.setState({
      vehicleData: data
    })
    if (is_handlevalidation) {
      this.handleValition();
    }
  }

  displayFleetDetail = (type) => {
    this.props.displayFleetDetail(type);
  }

  handleValition = () => {
    // if(this.props.from && this.props.from === 'registration'){
    //   return true;
    // }
    let { vehicleData, vehicleDeailError, rethreadError } = this.state;
    let isValid = false;

    if (vehicleData && Object.keys(vehicleData).length > 0) {
      if (vehicleData.totalCountTruck > 0 || vehicleData.totalCountBus > 0 || vehicleData.totalCountScv > 0 ||
        vehicleData.totalCountLcv > 0 || vehicleData.totalCountPickup > 0 || vehicleData.totalCountIcv > 0) {
        vehicleDeailError = false;
      } else {
        vehicleDeailError = true;
      }
      if (vehicleData.totalCountRetread) {
        rethreadError = false;
      } else {
        rethreadError = true;
      }
    } else {
      vehicleDeailError = true;
      rethreadError = true;
    }

    if (!vehicleDeailError && !rethreadError) {
      isValid = true;
    }

    this.setState({
      vehicleDeailError,
      rethreadError
    });

    return isValid;
  }
  openAddEditVehicleModal = (type, isAddVehicle = true) => {
    if (!this.state.isDisable) {
      this.props.openAddEditVehicle(type, isAddVehicle);
    } else {
      this.displayFleetDetail(type);
    }

  }

  deleteFleetVehicle = (vehicle_type) => {
    this.props.deleteFleetVehicle(vehicle_type);
  }

  render() {
    let { vehicleData,
      // frontData, 
      vehicleDeailError, rethreadError } = this.state;
    return (
      <>
        <Col xs="12" className='p-0'>
          <Card className="mt-2">
            <CardBody className="pb-0 pl-0 pr-0" style={{ fontSize: '12px', paddingLeft: '1px', paddingRight: '1px' }}>
              <Row>
                <Col xl="12" md="12" xs="12">
                  <b className="margin-right-16" style={{paddingLeft: '15px'}}>VEHICLE DETAILS</b>
                </Col>
              </Row>
              {/* <hr className="ml-n3 mr-n3" /> */}
              <Row className='m-0 mt-2 mb-3'>
                <Col lg="3" className='p-0'>
                  <div className='vehicleBlockWrapper' style={{borderLeft:0}}>
                    <div className='vehicleBlockInner'>
                      <div className='imgWrapper'>
                        <img src="images/vehicleImage/vehicleTruck.png" alt='vehicleTruck' className="vehicleImgIcon img-fluid" />
                      </div>
                      <div className='rightBlock'>
                        <div className='title cursor-pointer' onClick={() => this.openAddEditVehicleModal('truck', false)}>Truck ( ICV/ MHCV)</div>
                        <div className='d-flex'>
                          <div className='countWrapper'>
                            {
                              (vehicleData && vehicleData.totalCountTruck > 0) &&
                              <div>Vehicles: <b>{vehicleData.totalCountTruck}</b></div>
                            }
                            {
                              (vehicleData && vehicleData.totalCountTruck > 0) &&
                              <div>Wheels: <b>{vehicleData.totalWheelTruck || 0}</b></div>
                            }
                            {
                              (!vehicleData.totalCountTruck && !this.state.isDisable) &&
                              <div className='addBtnWrapper'>
                                <div className="addBtnBlock cursor-pointer" onClick={() => this.openAddEditVehicleModal('truck')}>
                                  <div className='plusIcon'>+</div>
                                  <div className="addText">Add</div>
                                </div>
                              </div>
                            }
                          </div>
                          {
                            (vehicleData && vehicleData.totalCountTruck > 0 && !this.state.isDisable) &&
                            <div className='addEditWrapper d-flex flex-column'>
                              <img onClick={() => this.openAddEditVehicleModal('truck', false)} className="cursor-pointer addEditIcon addIcon" src="images/edit.svg" alt='edit' />
                              <img className="cursor-pointer addEditIcon" src="images/delete.svg" onClick={() => this.deleteFleetVehicle('truck')} alt='edit-delete' />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.isDisable && vehicleData && vehicleData.totalCountTruck > 0 &&
                      <span className="d-flex mt-1">
                        <span className="cursor-pointer min-add-btn link-blue ml-auto" onClick={() => this.displayFleetDetail('truck')}>View Detail</span>
                      </span>
                    }
                  </div>
                </Col>
                <Col lg="3" className='p-0'>
                  <div className='vehicleBlockWrapper'>
                    <div className='vehicleBlockInner'>
                      <div className='imgWrapper'>
                        <img src="images/vehicleImage/vehicleBus.png" alt='vehicleBus' className="vehicleImgIcon img-fluid" />
                      </div>
                      <div className='rightBlock'>
                        <div className='title cursor-pointer' onClick={() => this.openAddEditVehicleModal('bus', false)}>Bus</div>
                        <div className='d-flex'>
                          <div className='countWrapper'>
                            {
                              (vehicleData && vehicleData.totalCountBus > 0) &&
                              <div>Vehicles: <b>{vehicleData.totalCountBus}</b></div>
                            }
                            {
                              (vehicleData && vehicleData.totalCountBus > 0) &&
                              <div>Wheels: <b>{vehicleData.totalWheelBus || 0}</b></div>
                            }
                            {
                              (!vehicleData.totalCountBus && !this.state.isDisable) &&
                              <div className='addBtnWrapper'>
                                <div className="addBtnBlock cursor-pointer" onClick={() => this.openAddEditVehicleModal('bus')}>
                                  <div className='plusIcon'>+</div>
                                  <div className="addText">Add</div>
                                </div>
                              </div>
                            }
                          </div>
                          {
                            (vehicleData && vehicleData.totalCountBus > 0 && !this.state.isDisable) &&
                            <div className='addEditWrapper d-flex flex-column'>
                              <img onClick={() => this.openAddEditVehicleModal('bus', false)} className="cursor-pointer addEditIcon addIcon" src="images/edit.svg" alt='edit' />
                              <img className="cursor-pointer addEditIcon" src="images/delete.svg" onClick={() => this.deleteFleetVehicle('bus')} alt='edit-delete' />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.isDisable && vehicleData && vehicleData.totalCountBus > 0 &&
                      <span className="d-flex mt-1">
                        <span className="cursor-pointer min-add-btn link-blue ml-auto" onClick={() => this.displayFleetDetail('bus')}>View Detail</span>
                      </span>
                    }
                  </div>
                </Col>
                <Col lg="3" className='p-0'>
                  <div className='vehicleBlockWrapper'>
                    <div className='vehicleBlockInner'>
                      <div className='imgWrapper'>
                        <img src="images/vehicleImage/vehicleLcv.png" alt='vehicleLcv' className="vehicleImgIcon img-fluid" />
                      </div>
                      <div className='rightBlock'>
                        <div className='title cursor-pointer' onClick={() => this.openAddEditVehicleModal('lcv', false)}>LCV / SCV / PICKUP</div>
                        <div className='d-flex'>
                          <div className='countWrapper'>
                            {
                              (vehicleData && vehicleData.totalCountLcv > 0) &&
                              <div>Vehicles: <b>{vehicleData.totalCountLcv}</b></div>
                            }
                            {
                              (vehicleData && vehicleData.totalCountLcv > 0) &&
                              <div>Wheels: <b>{vehicleData.totalWheelLCV || 0}</b></div>
                            }
                            {
                              (!vehicleData.totalCountLcv && !this.state.isDisable) &&
                              <div className='addBtnWrapper'>
                                <div className="addBtnBlock cursor-pointer" onClick={() => this.openAddEditVehicleModal('lcv')}>
                                  <div className='plusIcon'>+</div>
                                  <div className="addText">Add</div>
                                </div>
                              </div>
                            }
                          </div>
                          {
                            (vehicleData && vehicleData.totalCountLcv > 0 && !this.state.isDisable) &&
                            <div className='addEditWrapper d-flex flex-column'>
                              <img onClick={() => this.openAddEditVehicleModal('lcv', false)} className="cursor-pointer addEditIcon addIcon" src="images/edit.svg" alt='edit' />
                              <img className="cursor-pointer addEditIcon" src="images/delete.svg" onClick={() => this.deleteFleetVehicle('lcv')} alt='edit-delete' />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.isDisable && vehicleData && vehicleData.totalCountLcv > 0 &&
                      <span className="d-flex mt-1">
                        <span className="cursor-pointer min-add-btn link-blue ml-auto" onClick={() => this.displayFleetDetail('lcv')}>View Detail</span>
                      </span>
                    }
                  </div>
                </Col>
                <Col lg="3" className='p-0'>
                  <div className='vehicleBlockWrapper' style={{borderRight:0}}>
                    <div className='vehicleBlockInner'>
                      <div className='imgWrapper'>
                        <img src="images/vehicleImage/vehicleRetread.jpeg" alt='vehicleRetread' className="vehicleImgIcon img-fluid" style={{ width: '50px' }} />
                      </div>
                      <div className='rightBlock' style={{paddingLeft: '20px'}}>
                        <div className='title cursor-pointer' onClick={() => this.openAddEditVehicleModal('retread', false)}>Retread</div>
                        <div className='d-flex'>
                          {
                            (!vehicleData.totalCountRetread && !this.state.isDisable) &&
                            <div className='countWrapper'>
                              <div className='addBtnWrapper'>
                                <div className="addBtnBlock cursor-pointer" onClick={() => this.openAddEditVehicleModal('retread')}>
                                  <div className='plusIcon'>+</div>
                                  <div className="addText">Add</div>
                                </div>
                              </div>
                            </div>
                          }

                          {
                            (vehicleData && vehicleData.totalCountRetread > 0 && !this.state.isDisable) &&
                            <div className='addEditWrapper d-flex'>
                              <img onClick={() => this.openAddEditVehicleModal('retread', false)} className="cursor-pointer addEditIcon addIcon mb-0 mr-2" src="images/edit.svg" alt='edit' />
                              <img className="cursor-pointer addEditIcon" src="images/delete.svg" onClick={() => this.deleteFleetVehicle('retread')} alt='edit-delete' />
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.isDisable && vehicleData && vehicleData.totalCountRetread != null &&
                      <span className="d-flex mt-1">
                        <span className="cursor-pointer min-add-btn link-blue ml-auto" onClick={() => this.displayFleetDetail('retread')}>View Detail</span>
                      </span>
                    }
                  </div>
                </Col>
              </Row>
              {
                (vehicleDeailError || rethreadError) &&
                <Row xs="12">
                  <Col xl="12" md="12" xs="12">
                    {<div className="error" style={{ marginBottom: '10px', paddingLeft: '15px' }}>*Please add at least one vehicle detail and retread detail.</div>}
                  </Col>
                </Row>
              }
            </CardBody>
          </Card>
        </Col>

      </>
    );
  }
}

export default VehicleCountDeatil;